export class EnumHelper {
  static getApiEnumList<T, U>(_enum: T): U[] {
    return Object.entries(_enum).map((k: any) => k[0]);
  }
}
